import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    border: '1px solid #DEDEDE',
    borderRadius: 5,
    color: '#FFF',
    display: 'flex',
    height: 80,
    justifyContent: 'space-between',
    padding: 10,
    width: '100%',
  },

  widgetIcon: {
    color: '#FFF',
    fontSize: 40,
  },

  widgetContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 10,
    borderLeft: '1px solid white',
  },

  widgetValue: {
    fontSize: 24,
    fontWeight: 'bold',
  },

  widgetLabel: {
    fontSize: 14,
  },
}));

export default useStyles;
